import {
  Component,
  NgModule,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  model,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {
  FormArray,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { Observable, forkJoin } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { ToastComponent } from '../../../components/toast/toast.component';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { PermissionService } from '../../../components/Authentication/services/permission.service';
import { EmployeeService } from '../../../inputfileds/form_services/employee/employee.service';
import { UploadDialogComponent } from '../../../components/upload-dialog/upload-dialog.component';
import { ConnectiveservicesService } from '../../../Services/Apis/Connectiveservices/connectiveservices.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

export interface Employee {
  index: number;
  Name: number;
  Dost_ID: string;
  Roll_No: string;
  Department: string;
  Academic_Year: string;
  Action: any;
}

@Component({
  selector: 'app-listemployee',
  imports: [
    PaginationComponent,
    MatPaginatorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatButtonModule,
    MatInputModule,
    MatTableModule,
    MatCheckboxModule,
    DynamicFormQuestionComponent,
    MatIconModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatSnackBarModule,
    MatDialogModule,
    TranslateDirective
    // ToastComponent,
  ],
  templateUrl: './listemployee.component.html',
  styleUrl: './listemployee.component.scss',
})
export class ListemployeeComponent implements OnInit {
  getEmployeeData = [];
  paginationdata: any;
  EmployeeFilterForm!: FormGroup;
  EmployeeFilterFormQuestions: any[] = [];
  EmployeeFilterFormQuestions$: Observable<any[]> | null = null;
  dataSource = new MatTableDataSource<Employee>();
  selection = new SelectionModel<Employee>(true, []);
  filters: any;
  total_count: any;
  actiondata: any;
  @ViewChild(MatMenuTrigger) filterMenu!: MatMenuTrigger;
  displayedColumns: string[] = [
    'Name',
    'email',
    'phone_number',
    'employee_unique_id',
    'designation_name',
    'organization_name',
    'Action',
  ];
  constructor(
    private fb: FormBuilder,
    private apiservice: ApiservicesService,
    private router: Router,
    public dialog: MatDialog,
    private EmployeeService: EmployeeService,
    private permissionService: PermissionService,
    private connectiveservice: ConnectiveservicesService
  ) {
    this.actiondata = this.permissionService.getactiondata();
    if (this.actiondata?.view === false && this.actiondata?.edit === false) {
      this.displayedColumns.splice(this.displayedColumns.indexOf('actions'), 1);
    }
    this.EmployeeFilterForm = this.fb.group({
      department_id: [''],
    });
  }
  ngOnInit(): void {
    this.EmployeeFilterFormQuestions$ =
      this.EmployeeService.getFilterDropdowns();
    this.EmployeeFilterFormQuestions$.subscribe((q) => {
      this.EmployeeFilterFormQuestions = q;
    });
    this.getemployeelist();
  }

  pagination(event: any) {
    this.paginationdata = event;
    this.getemployeelist();
    this.filterEmployees(event);
  }

  filterEmployees(event: Event) {
    const formValues = this.EmployeeFilterForm.value;
    this.getemployeelist(formValues.department_id);
    this.filterMenu.closeMenu();
  }

  EmployeeFilterdisplay(event: any) {
    const filterdisplay_name = this.EmployeeService.DepartmentName.find((dept: any) => dept.id == event) || '0';
    return filterdisplay_name.key || '0';
  }

  clearFilter() {
    this.EmployeeFilterForm.reset();
    this.getemployeelist(); // Reset to the unfiltered list
    this.filterMenu.closeMenu(); // Optionally close the menu after clearing
  }

  closeAndDoSomething() {
    this.filterMenu.closeMenu();
  }

  getemployeelist(departmentId?: any) {
    if (departmentId != null || departmentId != undefined) {
      this.filters = { departmentId };
    } else {
      this.filters = {};
    }
    this.apiservice
      .getemployeelist(this.paginationdata, this.filters)
      .subscribe((res: any) => {
        this.dataSource = new MatTableDataSource<Employee>(res?.rows);
        this.total_count = res.total_count;
      });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: Employee): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.index + 1
      }`;
  }

  gotoemplyeeview(event: any) {
    this.router.navigate(['employeeview'], {
      queryParams: { dataId: event.id },
    });
  }
  gotoemplyeerole(event: any) {
    this.router.navigate(['employeelist/employeeroles'], {
      state: { empId: event.id },
    });
  }
  menuClosed(event: any) { }

  openUploadDialog(
    uploadType: 'details' | 'images',
    formDataKey: 'employeImages' | 'EMPLOYEES_BULKUPLOAD_TEMPLATE'
  ): void {
    let excelallowedFileTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];
    let zipallowedFileTypes = [
      'application/zip',
      'application/x-zip-compressed',
    ];
    let allowedFileTypes;
    if (formDataKey == 'EMPLOYEES_BULKUPLOAD_TEMPLATE') {
      allowedFileTypes = excelallowedFileTypes;
    } else {
      allowedFileTypes = zipallowedFileTypes;
    }
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      data: { uploadType, formDataKey, allowedFileTypes },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getemployeelist();
    });
  }

  navigatetoadd() {
    this.router.navigate(['employee']);
  }

  navigatetoedit(event: any) {
    this.connectiveservice.Employee_data = event;
    this.router.navigate(['employee']);
  }
}
